import { TimezoneDisplayFormat, TimezonePicker } from "@blueprintjs/timezone";
import { default as moment } from "moment";
import React from "react";

import { CalendarVariant } from "common/views/calendar/Calendar.view";
import DataCalendar from "common/views/calendar/DataCalendar";
import { DialogView } from "common/views/dialog/Dialog.view";
import { IPanelProps, Panel } from "core/decorators/Panel";
import BundleEntriesCalendarConfig from "./BundleEntriesCalendarConfig";
import Course from "./entities/Course";
import labelProvider from "./EntriesCalendar.labels";

/**
 * Panel for displaying bundle courses in a calendar view based on product displayStartDate and displayEndDate.
 *
 * @TODO add dialog + sidebar details views once consolidated "catalog" folder is created.
 * share components/fragments with details page.
 *
 * @author chris
 */

interface IBundleEntriesCalendarState {
	selected: Course | null;
}

const titleAccessor = (e: Course) => e.title;
const startAccessor = (timeZone: string) => (e: Course) => moment(e.displayStartDate).tz(timeZone).toDate();
const endAccessor = (timeZone: string) => (e: Course) => moment(e.displayEndDate).tz(timeZone).toDate();

@Panel({
	id: "bundle-entries-calendar",
	configClass: BundleEntriesCalendarConfig,
	labelProvider
})
export default class BundleEntriesCalendarPanel extends React.PureComponent<IPanelProps<BundleEntriesCalendarConfig>, IBundleEntriesCalendarState> {

	public state = { selected: null };

	public render() {
		const { config, language, timeZone } = this.props;

		const params: any = config.params || {};

		if (language) {
			params['language'] = language;
		}

		if (config.tags && config.tags.length > 0) {
			params.tagIds = config.tags;
			if (config.tagOrCondition) {
				params['tagOrCondition'] = true;
			}
		}

		// TODO fragment layout
		const calendar = (
			<div key="calendar">
				<div style={{paddingBottom: "15px", display: 'flex', justifyContent: 'space-between'}}>
					<TimezonePicker
						showLocalTimezone={true}
						value={this.props.timeZone}
						onChange={this.props.actions.userSetTimeZone}
						valueDisplayFormat={TimezoneDisplayFormat.COMPOSITE}
					/>
				</div>
				<DataCalendar
					entity={Course}
					params={params}
					rangeStartParam="displayRangeStart"
					rangeEndParam="displayRangeEnd"
					titleAccessor={titleAccessor}
					startAccessor={startAccessor(timeZone)}
					endAccessor={endAccessor(timeZone)}
					onSelectEvent={this.onSelectEvent}
					variant={CalendarVariant.DEFAULT}
					viewKey="calendar"
				/>
			</div>
		);

		if (config.detailsType === 'dialog') {

			return [
				calendar,
				(
					<DialogView
						onClose={() => this.onSelectEvent(null)}
						isOpen={!!this.state.selected}
						isCloseButtonShown={true}
						title="Event Details"
						viewKey="dialog"
						key="dialog"
					>
						{'(coming soon)'}
					</DialogView>
				)
			];
		}

		return calendar;
	}

	private onSelectEvent = (e: Course | null) => {
		if (!!e) {
			if (this.props.config.detailsType === 'redirect') {
				this.navigateToDetails(e);
			} else {
				this.setState({
					selected: !!this.state.selected && this.state.selected.id === e.id ? null : e
				});
			}
		} else {
			this.setState({selected: null});
		}
	}

	private navigateToDetails = (e: Course) => {
		const { actions, config } = this.props;
		if (config.detailsPage) {
			actions.pushPanelPath(config.detailsPage, { entryId: e.id });
		}
	}
}



// WEBPACK FOOTER //
// ./src/panels/entriesCalendar/BundleEntriesCalendar.panel.tsx